import Client from "..";
import { GameEvents } from "../utils/Types";
import { NineSlicePresets } from "./NineSlicePresets";
import { NumberCounter } from "./NumberCounter";

export class MoneyContainer extends Phaser.GameObjects.Container {
  private moneyBackground: Phaser.GameObjects.NineSlice;
  private moneyCounter: NumberCounter;

  constructor(scene: Phaser.Scene) {
    super(scene);

    this.moneyBackground = NineSlicePresets.Default(scene).setTint(0x0b9d5f);
    this.add(this.moneyBackground);

    this.moneyCounter = new NumberCounter(
      scene,
      Client.state.money,
      GameEvents.MONEY_UPDATED,
    )
      .setOrigin(0.5, 0.45)
      .SetPrefix("$")
      .SetAnimationColor(0x8de35d, 0xe82337)
      .SetAnimationScale(1.2, 0.8); // Scale up for increase, down for decrease
    this.add(this.moneyCounter);
  }

  Resize(width: number = this.width, height: number = this.height): this {
    this.setSize(width, height);

    this.moneyBackground.setSize(width, height).setDisplaySize(width, height);
    this.moneyBackground.setPosition(
      this.moneyBackground.displayWidth * 0.5,
      this.moneyBackground.displayHeight * 0.5,
    );

    this.moneyCounter.setFontSize(this.moneyBackground.displayHeight * 0.6);
    this.moneyCounter.setPosition(
      this.moneyBackground.x,
      this.moneyBackground.y,
    );

    return this;
  }
}
